export default __webpack_public_path__ + "static/media/register_briefcase.6dfc4518.svg";